var __jsx = React.createElement;
import React from 'react';
import useIsMobile from '@hooks/useIsMobile';
import { useCMS } from "@hooks/useCMS";
var FlatBanner = function FlatBanner(_ref) {
  var data = _ref.data;
  var isMobile = useIsMobile();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var bannerImage = isMobile ? data.image_mobile : data.image_desktop;
  return /*#__PURE__*/React.createElement("div", {
    id: "flat-banner-container",
    className: "w-full"
  }, /*#__PURE__*/React.createElement("img", {
    id: "flat-banner-image",
    loading: "lazy",
    src: imageUrl(bannerImage),
    alt: "Banner",
    className: "w-full h-auto object-cover"
  }));
};
export default FlatBanner;